export default {
  'kitchenDisplayScreenSettings.title': '厨房显示屏',

  'kitchenDisplayScreenSettings.virtual-kds.table.title': '虚拟KDS可以把设置存到云端，并快速应用到实体设备上。',
  'kitchenDisplayScreenSettings.virtual-kds.table.create': '+创建虚拟KDS',
  'kitchenDisplayScreenSettings.virtual-kds.table.column.name': '名称',
  'kitchenDisplayScreenSettings.virtual-kds.table.column.service-type': '服务类型',
  'kitchenDisplayScreenSettings.virtual-kds.table.column.usage': '用途',
  'kitchenDisplayScreenSettings.virtual-kds.table.column.display-mode': '展示模式',
  'kitchenDisplayScreenSettings.virtual-kds.table.column.mapped-screens': '映射数量',
  'kitchenDisplayScreenSettings.virtual-kds.table.column.mapped-screens.tips': '映射到这个虚拟KDS的实体设备数量',
  'kitchenDisplayScreenSettings.virtual-kds.table.column.auto-print': '自动打印',
  'kitchenDisplayScreenSettings.virtual-kds.table.column.action': '操作',
  'kitchenDisplayScreenSettings.virtual-kds.form.title.create': '创建新的虚拟厨显屏',
  'kitchenDisplayScreenSettings.virtual-kds.form.title.edit': '编辑虚拟厨显屏',
  'kitchenDisplayScreenSettings.virtual-kds.form.exit.title': '确认退出吗?',
  'kitchenDisplayScreenSettings.virtual-kds.form.exit.description':
    '如果现在退出，当前的设置将会丢失，您需要重新开始。',
  'kitchenDisplayScreenSettings.virtual-kds.form.section.step.1': '第1步（共3步）',
  'kitchenDisplayScreenSettings.virtual-kds.form.section.step.2': '第2步（共3步）',
  'kitchenDisplayScreenSettings.virtual-kds.form.section.step.3': '第3步（共3步）',
  'kitchenDisplayScreenSettings.virtual-kds.form.coming-soon': '敬请期待',
  'kitchenDisplayScreenSettings.virtual-kds.form.field.name.long': '请为这台虚拟厨显屏命名',
  'kitchenDisplayScreenSettings.virtual-kds.form.field.name.short': '名字',
  'kitchenDisplayScreenSettings.virtual-kds.form.field.name.placeholder': '请输入这台虚拟厨显屏的名字',
  'kitchenDisplayScreenSettings.virtual-kds.form.field.role': '这个厨显屏主要用来做什么？',
  'kitchenDisplayScreenSettings.virtual-kds.form.field.role.runner-display': '传菜屏',
  'kitchenDisplayScreenSettings.virtual-kds.form.field.role.runner-display.tips':
    '这是传菜屏，用于在菜品送至餐桌前标记订单或菜品为已完成。',
  'kitchenDisplayScreenSettings.virtual-kds.form.field.role.cooking-display': '制作屏',
  'kitchenDisplayScreenSettings.virtual-kds.form.field.role.cooking-display.tips':
    '这是用于厨房各工位的制作屏，用于接收待制作的各个订单或菜品，并显示给相关厨房工作人员。',
  'kitchenDisplayScreenSettings.virtual-kds.form.field.display-mode.group-style': '为这台虚拟厨显屏选择一个展示模式',
  'kitchenDisplayScreenSettings.virtual-kds.form.field.display-mode.group-style.order-based': '按订单展示',
  'kitchenDisplayScreenSettings.virtual-kds.form.field.display-mode.group-style.order-based.tips':
    '每个订单单独显示，所有细节一目了然。',
  'kitchenDisplayScreenSettings.virtual-kds.form.field.display-mode.group-style.show-each-dish-separately': '一菜一单',
  'kitchenDisplayScreenSettings.virtual-kds.form.field.display-mode.group-style.show-each-dish-separately.tips':
    '每道菜单独显示，方便厨房清楚了解每份菜品的制作需求。',
  'kitchenDisplayScreenSettings.virtual-kds.form.field.display-mode.group-style.combine-same-dishes':
    '相同菜品合并显示',
  'kitchenDisplayScreenSettings.virtual-kds.form.field.display-mode.group-style.combine-same-dishes.tips':
    '相同的菜品会合并显示并标注总数量，方便批量制作。',
  'kitchenDisplayScreenSettings.virtual-kds.form.field.display-mode.view-style': '请选择此虚拟厨显屏的显示方式',
  'kitchenDisplayScreenSettings.virtual-kds.form.field.display-mode.view-style.dynamic-view': '动态瀑布流视图',
  'kitchenDisplayScreenSettings.virtual-kds.form.field.display-mode.view-style.dynamic-view.tips': '订单将动态排列。',
  'kitchenDisplayScreenSettings.virtual-kds.form.field.display-mode.view-style.fixed-view': '每个订单固定显示一列',
  'kitchenDisplayScreenSettings.virtual-kds.form.field.display-mode.view-style.fixed-view.tips':
    '每个订单将固定显示在一列中。',
  'kitchenDisplayScreenSettings.virtual-kds.form.field.display-mode.show-kds-summary-on-left': '是否展示菜品汇总？',
  'kitchenDisplayScreenSettings.virtual-kds.form.field.display-mode.show-kds-summary-on-left.yes': '是',
  'kitchenDisplayScreenSettings.virtual-kds.form.field.display-mode.show-kds-summary-on-left.yes.tips':
    '屏幕左侧会显示菜品汇总，能快速看到每种菜品的数量。',
  'kitchenDisplayScreenSettings.virtual-kds.form.field.display-mode.show-kds-summary-on-left.no': '否',
  'kitchenDisplayScreenSettings.virtual-kds.form.field.display-mode.show-kds-summary-on-left.no.tips': '隐藏菜品汇总。',
  'kitchenDisplayScreenSettings.virtual-kds.form.field.service-types': '请选择此虚拟厨显屏的服务类型',
  'kitchenDisplayScreenSettings.virtual-kds.form.field.service-types.placeholder': '服务类型',
  'kitchenDisplayScreenSettings.virtual-kds.form.field.service-types.tips': '按服务类型筛选订单，确保只显示相关订单',
  'kitchenDisplayScreenSettings.virtual-kds.form.field.kds-meal-prototypes': '请选择要显示的菜品',
  'kitchenDisplayScreenSettings.virtual-kds.form.field.kds-meal-prototypes.tips':
    '选出你希望显示在这块屏上的菜品，没选中的则不会显示。',
  'kitchenDisplayScreenSettings.virtual-kds.form.field.kds-meal-prototypes.select-all': '全选',
  'kitchenDisplayScreenSettings.virtual-kds.form.modal.success.title': '设置完成！您已成功配置这台虚拟厨显屏。',
  'kitchenDisplayScreenSettings.virtual-kds.form.modal.success.description':
    '图片仅供参考，请在您的硬件设备上完成虚拟厨显屏的映射（如图）。',
  'kitchenDisplayScreenSettings.virtual-kds.form.modal.success.img.tips': '图片仅供参考',

  'kitchenDisplayScreenSettings.timeout-alert.field.order-timeout-thresholds': '订单超时阈值',
  'kitchenDisplayScreenSettings.timeout-alert.field.order-timeout-thresholds.tips':
    '为所有订单设置阈值。当订单达到一级或二级阈值时，将以对应的颜色高亮显示。',
  'kitchenDisplayScreenSettings.timeout-alert.field.order-timeout-thresholds.name': '名称',
  'kitchenDisplayScreenSettings.timeout-alert.field.order-timeout-thresholds.name.1': '一级',
  'kitchenDisplayScreenSettings.timeout-alert.field.order-timeout-thresholds.name.2': '二级',
  'kitchenDisplayScreenSettings.timeout-alert.field.order-timeout-thresholds.enabled': '启用',
  'kitchenDisplayScreenSettings.timeout-alert.field.order-timeout-thresholds.thresholds': '超时阈值（分钟）',
  'kitchenDisplayScreenSettings.timeout-alert.field.order-timeout-thresholds.thresholds.tips':
    '当订单时间超过某个级别时，将以对应的颜色高亮显示。',
  'kitchenDisplayScreenSettings.timeout-alert.field.order-timeout-thresholds.thresholds.mintues': '分钟',
  'kitchenDisplayScreenSettings.timeout-alert.field.order-timeout-thresholds.thresholds.error':
    '二级超时时间阈值必须大于一级超时时间。',
  'kitchenDisplayScreenSettings.timeout-alert.field.order-timeout-thresholds.color-preview': '颜色预览',
  'kitchenDisplayScreenSettings.timeout-alert.field.order-timeout-thresholds.color-preview.tips':
    '当任一订单超过 L1 或 L2 阈值时，将触发显示对应颜色。',
  'kitchenDisplayScreenSettings.timeout-alert.field.order-timeout-thresholds.color-preview.delivery': '递送',

  'kitchenDisplayScreenSettings.general-settings.section.master-device-id': 'KDS主机选择',
  'kitchenDisplayScreenSettings.general-settings.field.master-device-id': '选择一台实体设备作为KDS主机',
  'kitchenDisplayScreenSettings.general-settings.field.master-device-id.tips.title': 'KDS主机选择指南',
  'kitchenDisplayScreenSettings.general-settings.field.master-device-id.tips.content.1':
    '1. 将 KDS Server 放置在电源和网络可靠的位置。',
  'kitchenDisplayScreenSettings.general-settings.field.master-device-id.tips.content.2':
    '2. 尽量使用有线连接，并保留静态 IP。',
  'kitchenDisplayScreenSettings.general-settings.field.master-device-id.tips.content.3': '3. 点击“保存”以应用更改。',
  'kitchenDisplayScreenSettings.general-settings.field.master-device-id.tips.content.4':
    '4. 所有 KDS 设备在保存新 KDS Server 后需要几分钟初始化时间。',
  'kitchenDisplayScreenSettings.general-settings.field.master-device-id.tips.content.5':
    '5. 确保所选设备当前已接通电源并联网。该设备异常可能影响其他KDS的运行。',
  'kitchenDisplayScreenSettings.general-settings.field.master-device-id.table.column.device-name': '设备名称',
  'kitchenDisplayScreenSettings.general-settings.field.master-device-id.table.column.serial-number': '序列号',
  'kitchenDisplayScreenSettings.general-settings.field.master-device-id.table.column.last-heartbeat-time':
    '最后一次心跳时间',
  'kitchenDisplayScreenSettings.general-settings.field.master-device-id.table.column.mapped-virtual-kds':
    '映射的虚拟厨显屏',
  'kitchenDisplayScreenSettings.virtual-kds.form.modal.kds-server-updated.title': '所选KDS主机已保存',
  'kitchenDisplayScreenSettings.virtual-kds.form.modal.kds-server-updated.description.1':
    '所有KDS设备正在与新主机同步，预计需要几分钟。',
  'kitchenDisplayScreenSettings.virtual-kds.form.modal.kds-server-updated.description.2':
    '同步完成后，之前和同步过程中新增的订单将正常显示。',
  'kitchenDisplayScreenSettings.virtual-kds.form.modal.kds-server-updated.got-it': '知道了',
};
